import { startCase, lowerCase } from "lodash-es";
import { sha1 } from "js-sha1";
import { sha256 } from "js-sha256";

export function toSentenceCase(str: string, capitalize = true) {
  if (!str || typeof str !== "string") return "";

  if (capitalize) return startCase(lowerCase(str));
  else return lowerCase(str);
}

export function arrayToMarkdownList(arr: string[]) {
  if (!arr || !Array.isArray(arr)) return "";
  return arr.map(item => `- ${item}`).join("\n");
}

export const formatHumanReadableNumber = (n: number) => {
  const formatter = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 1,
    minimumFractionDigits: 0,
    notation: "compact",
  });
  return formatter.format(n || 0);
};

export function truncateStringAfterWord(text: string, maxLength: number) {
  if (!text || text.length <= maxLength) return text;
  const index = text.indexOf(" ", maxLength - 1);
  return index === -1
    ? text.substring(0, maxLength) + "..."
    : text.substring(0, index) + "...";
}

export function decodeCommonHtmlEntities(str: string) {
  if (!str || typeof str !== "string" || str.length < 3) return str;
  const htmlEntities = [
    { entity: "&nbsp;", char: " " },
    { entity: "&amp;", char: "&" },
    { entity: "&quot;", char: '"' },
    { entity: "&lt;", char: "<" },
    { entity: "&gt;", char: ">" },
    { entity: "&apos;", char: "'" },
    { entity: "&#39;", char: "'" },
    { entity: "&cent;", char: "¢" },
    { entity: "&pound;", char: "£" },
    { entity: "&yen;", char: "¥" },
    { entity: "&euro;", char: "€" },
    { entity: "&copy;", char: "©" },
    { entity: "&reg;", char: "®" },
    { entity: "&sect;", char: "§" },
    { entity: "&hellip;", char: "…" },
    { entity: "&deg;", char: "°" },
    { entity: "&asymp;", char: "≈" },
    { entity: "&ne;", char: "≠" },
    { entity: "&le;", char: "≤" },
    { entity: "&ge;", char: "≥" },
    { entity: "&para;", char: "¶" },
    { entity: "&times;", char: "×" },
    { entity: "&divide;", char: "÷" },
    { entity: "&micro;", char: "µ" },
    { entity: "&trade;", char: "™" },
    { entity: "&not;", char: "¬" },
    { entity: "&eth;", char: "ð" },
    { entity: "&aelig;", char: "æ" },
    { entity: "&oelig;", char: "œ" },
    { entity: "&aring;", char: "å" },
    { entity: "&ccedil;", char: "ç" },
    { entity: "&uuml;", char: "ü" },
    { entity: "&iuml;", char: "ï" },
    { entity: "&oacute;", char: "ó" },
    { entity: "&oslash;", char: "ø" },
    { entity: "&szlig;", char: "ß" },
    { entity: "&#8217;", char: "’" },
    { entity: "&#8220;", char: "“" },
    { entity: "&#8221;", char: "”" },
    { entity: "&#8230;", char: "…" },
  ];

  htmlEntities.forEach(entity => {
    str = str.replace(new RegExp(entity.entity, "g"), entity.char);
  });
  return str;
}

export function getSha1Hash(s: string) {
  return sha1(s);
}

export function getSha256Hash(s: string) {
  const hash = sha256.create();
  hash.update(s);
  return hash.hex();
}
